import ShopServiceModel from '@/models/ShopServiceModel';

export default class DeliverableTransferClaimByCodeModel extends ShopServiceModel {
	static get path(): string {
		return '/deliverable_transfers/_claim_by_code';
	}
}
